import React from "react";
import { useStores } from "../../store";

const Table = ({ data }) => {
  const { MockStore } = useStores();
  return (
    <div className="overflow-x-auto">
      <table className="table-auto border-collapse mt-7 w-[100%]">
        <thead className="w-[100%]">
          <tr
            className="w-[100%] max-sm:text-[0.75rem] max-sm:h-8"
            style={{ backgroundColor: "#FF6B00", color: "white" }}
          >
            <th className=" md:px-4 md:py-2 max-sm:w-[10%]  ">S.No</th>
            <th className="md:px-4 md:py-2 max-sm:w-[20%]">Topic name</th>
            <th className="md:px-4 md:py-2 max-sm:hidden ">Total Questions</th>
            <th className="md:px-4 md:py-2 max-sm:w-[35%] ">Correct answers</th>
            <th className="px-4 py-2 max-sm:hidden">Wrong answers</th>
            <th className="md:px-4 md:py-2 max-sm:w-[35%]">
              Overall percentage
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b">
            <td className="px-4 py-2 text-center">{1}</td>
            <td className=" md:px-4 max-sm:px-1 py-2">Aptitude</td>
            <td className=" px-4 py-2 text-center max-sm:hidden ">
              {MockStore.report?.categoryWiseReport?.Aptitude?.total ?? 0}
            </td>
            <td className="px-4 py-2 text-center md:hidden">
              {MockStore.report?.categoryWiseReport?.Aptitude?.correct ?? 0 }
            </td>
            <td className="px-4 py-2 text-center max-sm:hidden">
              {MockStore.report?.categoryWiseReport?.Aptitude?.correct ?? 0}
            </td>
            <td className="px-4 py-2 text-center max-sm:hidden ">
              {MockStore.report?.categoryWiseReport?.Aptitude?.incorrect ?? 0}
            </td>
            <td className="px-4 py-2 text-center">
              {MockStore.report?.categoryWiseReport?.Aptitude?.accuracy?.toFixed(0) ?? 0}
            </td>
          </tr>
          <tr  className="border-b">
              <td className="px-4 py-2 text-center">{2}</td>
              <td className=" md:px-4 max-sm:px-1 py-2">Reasoning</td>
              <td className=" px-4 py-2 text-center max-sm:hidden ">{MockStore.report?.categoryWiseReport?.Reasoning?.total ?? 0}</td>
              <td className="px-4 py-2 text-center md:hidden">{MockStore.report?.categoryWiseReport?.Reasoning?.correct ?? 0 }</td>
              <td className="px-4 py-2 text-center max-sm:hidden">{MockStore.report?.categoryWiseReport?.Reasoning?.correct ?? 0}</td>
              <td className="px-4 py-2 text-center max-sm:hidden ">{MockStore.report?.categoryWiseReport?.Reasoning?.incorrect ?? 0}</td>
              <td className="px-4 py-2 text-center">{MockStore.report?.categoryWiseReport?.Reasoning?.accuracy?.toFixed(0) ?? 0}</td>
             
            </tr>
            <tr  className="border-b">
              <td className="px-4 py-2 text-center">{3}</td>
              <td className=" md:px-4 max-sm:px-1 py-2">Verbal</td>
              <td className=" px-4 py-2 text-center max-sm:hidden ">{MockStore.report?.categoryWiseReport?.Verbal?.total ?? 0}</td>
              <td className="px-4 py-2 text-center md:hidden">{MockStore.report?.categoryWiseReport?.Verbal?.correct ?? 0}</td>
              <td className="px-4 py-2 text-center max-sm:hidden">{MockStore.report?.categoryWiseReport?.Verbal?.correct ?? 0 }</td>
              <td className="px-4 py-2 text-center max-sm:hidden ">{MockStore.report?.categoryWiseReport?.Verbal?.incorrect ?? 0}</td>
              <td className="px-4 py-2 text-center">{MockStore.report?.categoryWiseReport?.Verbal?.accuracy?.toFixed(0) ?? 0}</td>
             
            </tr>
            {MockStore.report?.mockTestName&&<tr  className="border-b">
              <td className="px-4 py-2 text-center">{4}</td>
              <td className=" md:px-4 max-sm:px-1 py-2">{MockStore.report?.mockTestName}</td>
              <td className=" px-4 py-2 text-center max-sm:hidden ">{MockStore.report?.categoryWiseReport[MockStore.report?.mockTestName]?.total ?? 0}</td>
              <td className="px-4 py-2 text-center md:hidden">{MockStore.report?.categoryWiseReport[MockStore.report?.mockTestName]?.correct ?? 0 }</td>
              <td className="px-4 py-2 text-center max-sm:hidden">{MockStore.report?.categoryWiseReport[MockStore.report?.mockTestName]?.correct?? 0}</td>
              <td className="px-4 py-2 text-center max-sm:hidden ">{MockStore.report?.categoryWiseReport[MockStore.report?.mockTestName]?.incorrect?? 0}</td>
              <td className="px-4 py-2 text-center">{MockStore.report?.categoryWiseReport[MockStore.report?.mockTestName]?.accuracy?.toFixed(0) ?? 0}</td>
             
            </tr>}

        </tbody>
      </table>
    </div>
  );
};

export default Table;
